
  import {createControllersWithDescriptors, initAppForPageWrapper} from '@wix/yoshi-flow-editor/runtime/esm/viewerScript/wrapper.js';
  
  

  
  var importedApp = {};


  

    var velocycleMobx = null;
    


  

    var blocksControllerService = null;
    

  
var createHttpClient = null;

  

  import { initI18nWithoutICU as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


  
const multilingualDisabled = false;

  

    var createExperiments = null;
    var createWidgetExperiments = null;
    


  var sentryConfig = {
      DSN: 'https://ed436f5053144538958ad06a5005e99a@sentry.wixpress.com/6142',
      id: 'undefined',
      projectName: 'members-area-notifications--0j',
      teamName: 'ping',
      errorMonitor: true,
    };

  var experimentsConfig = {"scopes":["viewer-apps-14f25dc5-6af3-5420-9568-f9c5ed98c9b1"],"centralized":true};

  var translationsConfig = {"icuEnabled":false,"defaultTranslationsPath":"/home/builduser/work/2bdd11b345a24aaa/packages/members-area-notifications-preferences/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};

  var defaultTranslations = {"app.settings.tabs.design.title-font.title":"Title text","dummy.app.forum.displayName":"Forum","app.widget.marketing-emails.subscription.subscribe":"Subscribe Now","dummy.preferences.forum.topic_3":"Likes or reactions","dummy.app.invoices.displayName":"Invoices","dummy.preferences.invoices.topic_1":"Invoice issued","dummy.preferences.blog.topic_2":"Comments on posts","app.widget.PROMOTIONAL.title":"Marketing emails","dummy.app.inbox.displayName":"Inbox","app.settings.tabs.design.background-section.title":"Backgrounds and borders","app.settings.tabs.design.border-color.title":"Border opacity and color","dummy.preferences.invoices.topic_2":"Invoice is overdue","app.settings.tabs.design.button-text-color.title":"Button text color","app.settings.tabs.design":"Design","dummy.preferences.blog.topic_1":"Posts or comments are liked","app.widget.TRANSACTIONAL.title":"Business transactional emails ","app.widget.marketing-emails.subscription-toast.error":"Email preferences weren't saved due to a technical issue on our end. Try again.","dummy.preferences.forum.topic_4":"New posts","app.widget.marketing-emails.subscription-toast.success.subscribed":"You're subscribed to all marketing emails.","app.settings.tabs.design.button-section.title":"Button style","app.settings.tabs.design.border-width.title":"Border width","app.widget.marketing-emails.subscription-toast.success.unsubscribed":"You're unsubscribed from all marketing emails. You'll still get important emails about your account.","app.widget.marketing-emails.subscription.title.subscribed":"You are subscribed to marketing emails","app.settings.tabs.design.background-color.title":"Background opacity and color","app.settings.tabs.design.primary-font.title":"Body text","app.settings.tabs.design.text-color.title":"Text color","dummy.preferences.forum.topic_1":"Daily or weekly activity summary","app.settings.tabs.design.button-opacity-and-color.title":"Button opacity and color","app.settings.label":"Settings","app.widget.title":"Email notification settings","app.widget.subtitle":"Choose what you want to get notified about.","app.widget.marketing-emails.subscription.title.unsubscribed":"You aren't subscribed to marketing emails","dummy.preferences.forum.topic_2":"Comments or replies","dummy.preferences.inbox.topic_1":"New messages","dummy.app.blog.displayName":"Blog","app.widget.marketing-emails.subscription.unsubscribe":"Unsubscribe"};

  var fedopsConfig = null;

  import { createVisitorBILogger as biLogger } from '/home/builduser/work/2bdd11b345a24aaa/packages/members-area-notifications-preferences/target/generated/bi/createBILogger.ts';

  export const exports = importedApp.exports;

  export const initAppForPage = initAppForPageWrapper({
    initAppForPage: importedApp.initAppForPage,
    sentryConfig: sentryConfig,
    experimentsConfig: experimentsConfig,
    inEditor: false,
    biLogger: biLogger,
    multilingualDisabled,
    projectName: "members-area-notifications-preferences",
    biConfig: null,
    appName: "Members Notifications Settings",
    appDefinitionId: "14f25dc5-6af3-5420-9568-f9c5ed98c9b1",
    fedopsConfig: fedopsConfig,
    translationsConfig: translationsConfig,
    defaultTranslations: defaultTranslations,
    shouldUseEssentials: true,
    optionalDeps: {
      initI18n,
      createHttpClient,
      createExperiments,
    },
    localeDistPath: "assets/locales",
  });

  const _createControllers = createControllersWithDescriptors({
    initI18n,
    blocksControllerService,
    createHttpClient,
    createExperiments,
    velocycleMobx,
  }, [{ method: null,
          wrap: null,
          exports: null,
          widgetType: "WIDGET_OUT_OF_IFRAME",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["viewer-apps-14f25dc5-6af3-5420-9568-f9c5ed98c9b1"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/2bdd11b345a24aaa/packages/members-area-notifications-preferences/src/components/PreferencesOoi/controller.ts",
          appName: "Members Notifications Settings",
          appDefinitionId: "14f25dc5-6af3-5420-9568-f9c5ed98c9b1",
          projectName: "members-area-notifications-preferences",
          componentName: "PreferencesOoi",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14f25dd2-f9b0-edc2-f38e-eded5da094aa" }],
    false);

    export const createControllers = _createControllers
